<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card">
      <input
        type="text"
        class="dir-rtl main-input ti-input"
        v-model="model.subject"
        placeholder="موضوع تیکت"
      />
      <textarea
        rows="4"
        cols="50"
        class="dir-rtl main-input ti-input"
        v-model="model.text"
        placeholder="توضیحات"
      />
    </div>
    <button class="m-btn f-bootom" @click="sendTicketHandler">ثبت</button>
  </div>
</template>

<script>
import InsHeader from "../../../layouts/inside-header.vue";
export default {
  components: {
    InsHeader,
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {
      model: {},
    };
  },
  methods: {
    sendTicketHandler() {
      this.$store.dispatch("ticket/sendTicket", this.model);
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.f-bootom {
  position: fixed;
  bottom: 22px;
  right: 6px;
  width: 95%;
}
.ti-input {
  margin-top: 10px;
  width: 95%;
}
</style>
